import React from "react";
import { toInitials } from "../../utilities";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  getServiceCenterUserApi,
  getServiceCenterUsersExportApi,
} from "../../services/ServiceApi";
import Pagination from "../Constant/Pagination";
import { Spinner } from "react-bootstrap";
import DebounceSmallSearchInput from "../Constant/DebounceSmallSearchInput";
import { CancelRequest } from "../../services/AxiosInstance";
import { useParams } from "react-router-dom";
import { CustomTooltip } from "../../components/CustomTooltip";
import { BiSolidFileExport } from "react-icons/bi";
import { toast } from "react-toastify";
import { FaDownload } from "react-icons/fa";
const ServiceCenterUsers = () => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [exportLoading, setExportLoading] = useState(false);
  const [param, setParam] = useState({
    page: "1",
    page_size: "10",
    query: "",
  });

  const getData = () => {
    setLoading(true);
    getServiceCenterUserApi(id, param)
      .then((res) => {
        setError("");
        setData(res?.data?.results || []);
        setTotal(res?.data?.count || 0);
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getData();
  }, [param]);
  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  };

  const handleExport = () => {
    setExportLoading(true);
    getServiceCenterUsersExportApi(id,{ ...param, export: true })
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "Service-center-users.xlsx";

        // Append to DOM to make it more consistent
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setExportLoading(false);
      });
  };
  return (
    <div>
      <div className="p-2 d-flex justify-content-between gap-2 flex-wrap">
        <div className="d-flex gap-1 flex-fill flex-md-grow-0">
          <div className="flex-fill">
            <DebounceSmallSearchInput handleSearchChange={handleSearchChange} />
          </div>
        </div>
        <div>
          <CustomTooltip title="Export">
            <button
              className="btn btn-success"
              style={{ padding: "0.6rem 0.6rem" }}
              onClick={handleExport}
              disabled={exportLoading||data?.length==0}
            >
              {exportLoading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                <FaDownload size="16" />
              )}
            </button>
          </CustomTooltip>
        </div>
      </div>
      {loading ? (
        <div className="text-center my-4">
          <Spinner animation="border" />
        </div>
      ) : error ? (
        <div className="text-center my-4 text-danger">{error}</div>
      ) : data && data?.length > 0 ? (
        <div className="table-responsive">
          <table className="table fs-6 mb-0 align-middle">
            <thead className="table-light custom-thead">
              <tr>
                <th>User</th>
                <th>Mobile Number</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((item, index) => (
                <tr key={item.id}>
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <div
                        className="rounded-circle bg-light text-dark d-flex justify-content-center align-items-center overflow-hidden"
                        style={{
                          width: "35px",
                          height: "35px",
                          fontWeight: 500,
                          fontSize: "0.9rem",
                        }}
                      >
                        <span>{toInitials(item?.name)}</span>
                      </div>
                      <div>
                        <Link className="text-uppercase text-primary fw-bold d-block">
                          {item?.name}
                        </Link>
                        <Link className="small text-secondary d-block">
                          {item?.email || "-"}
                        </Link>
                      </div>
                    </div>
                  </td>
                  <td>{item?.mobile_number || "-"}</td>
                  <td>
                    {item?.is_active ? (
                      <span className="badge text-bg-success-soft rounded-pill">
                        Active
                      </span>
                    ) : (
                      <span className="badge text-bg-danger-soft rounded-pill">
                        In Active
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="text-center my-4">No data found</div>
      )}
      {!loading && data?.length > 0 && (
        <div className="p-1">
          <Pagination
            currentPage={param.page}
            recordsPage={param.page_size}
            dataLength={total}
            handlePagination={handlePageChange}
          />
        </div>
      )}
    </div>
  );
};

export default ServiceCenterUsers;
